export default "__VITE_ASSET__ClKliYCr__"